(function () {
  'use strict';

  function loadData(sectionId) {
    var el = document.getElementById('backorder-variant-data-' + sectionId);
    if (!el) {
      console.error('[backorder-pdp] JSON script tag not found for section:', sectionId);
      return null;
    }
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error('[backorder-pdp] JSON parse error:', e, '\nContent:', el.textContent.slice(0, 200));
      return null;
    }
  }

  function findSectionId() {
    var el = document.querySelector('[id^="backorder-variant-data-"]');
    if (!el) {
      console.error('[backorder-pdp] No backorder data element found on page');
      return null;
    }
    try {
      return JSON.parse(el.textContent).sectionId;
    } catch (e) {
      console.error('[backorder-pdp] Failed to parse sectionId:', e);
      return null;
    }
  }

  function applyState(variantId, sectionId, variant) {
    var data = loadData(sectionId);
    if (!data) return;

    var vd = data.variants[String(variantId)];
    if (!vd) {
      console.warn('[backorder-pdp] No data for variant:', variantId, 'Known variants:', Object.keys(data.variants));
      return;
    }

    var isActive = vd.backorder_enabled === true && vd.inventory_quantity <= 0;
    updateButton(isActive, sectionId);
    updateMessage(isActive, vd, sectionId);
    updatePriceState(isActive, sectionId, variant);
  }

  function clearBackorderState(sectionId) {
    var wrapper = document.getElementById('backorder-message-' + sectionId);
    if (wrapper) wrapper.hidden = true;
    updatePriceState(false, sectionId, null);
  }

  function updateButton(isActive, sectionId) {
    var btn = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!btn) return;
    if (!isActive) {
      btn.classList.remove('product-form__submit--preorder');
      return;
    }
    btn.removeAttribute('disabled');
    btn.classList.add('product-form__submit--preorder');
    var span = btn.querySelector('span');
    if (span) span.textContent = 'Pre Order';
    var form = btn.closest('product-form');
    if (form) {
      var variantInput = form.querySelector('.product-variant-id');
      if (variantInput) variantInput.disabled = false;
    }
  }

  function updateMessage(isActive, variantData, sectionId) {
    var wrapper = document.getElementById('backorder-message-' + sectionId);
    if (!wrapper) return;
    if (!isActive) {
      wrapper.hidden = true;
      return;
    }
    var date = variantData.display_date || '';
    var dateEl = wrapper.querySelector('.preorder-badge__date-value');
    var datePara = wrapper.querySelector('.preorder-badge__date');
    if (dateEl) dateEl.textContent = date;
    if (datePara) datePara.hidden = !date;
    wrapper.hidden = false;
  }

  function updatePriceState(isActive, sectionId, variant) {
    var priceRoot = document.getElementById('price-' + sectionId);
    if (!priceRoot) return;

    var priceEl = priceRoot.querySelector('.price');
    if (!priceEl) return;

    priceEl.classList.toggle('price--preorder', isActive);
    if (isActive) {
      priceEl.classList.remove('price--sold-out');
      return;
    }

    if (variant) {
      priceEl.classList.toggle('price--sold-out', variant.available === false);
    }
  }

  function getSelectedVariant() {
    var selectedVariantEl = document.querySelector('variant-selects [data-selected-variant]');
    if (!selectedVariantEl) return null;
    try {
      return JSON.parse(selectedVariantEl.textContent);
    } catch (e) {
      console.error('[backorder-pdp] Failed to parse selected variant JSON:', e);
      return null;
    }
  }

  function init() {
    var sectionId = findSectionId();
    if (!sectionId) return;

    // Apply state for the variant already selected on page load
    var form = document.getElementById('product-form-' + sectionId);
    var input = form && form.querySelector('input[name="id"]');
    if (input && input.value) {
      applyState(input.value, sectionId, getSelectedVariant());
    }

    // Dawn publishes 'variant-change' AFTER toggleSubmitButton runs,
    // so no setTimeout is needed — we can override directly.
    if (typeof subscribe === 'function') {
      subscribe('variant-change', function (eventData) {
        var variant = eventData && eventData.data && eventData.data.variant;
        if (variant) {
          applyState(variant.id, sectionId, variant);
        } else {
          // Unavailable combination — hide backorder message
          clearBackorderState(sectionId);
        }
      });
    } else {
      // Fallback: listen on input change with setTimeout to defer after toggleSubmitButton
      if (input) {
        input.addEventListener('change', function () {
          var variantId = input.value;
          if (!variantId) {
            clearBackorderState(sectionId);
            return;
          }
          setTimeout(function () { applyState(variantId, sectionId, getSelectedVariant()); }, 0);
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
